import jwkToPem from 'jwk-to-pem'
import JSEncrypt from 'jsencrypt'

async function getPublicKey() {
  return await fetch('/api/wms/v1/auth/rsa/publicKey')
    .then(res => res.json())
    .then(res => res)
    .catch(_ => null)
}

const JWK_KEY = 'jwt'
const getJWK = () => {
  const cache = localStorage.getItem(JWK_KEY)
  if (cache) return JSON.parse(cache)
  return null
}
const setJWK = jwk => localStorage.setItem(JWK_KEY, JSON.stringify(jwk))

export async function encryptData(data) {
  let jwk = getJWK()
  if (!jwk) {
    jwk = await getPublicKey()
    jwk = jwk.keys[0]
    if (!jwk) throw new Error('failed to get encrypted key')
  }
  const encrypt = new JSEncrypt()
  const pem = jwkToPem(jwk)
  encrypt.setPublicKey(pem)
  const encrypted = encrypt.encrypt(data)
  if (encrypted === false) throw new Error('failed to encrypt data')
  setJWK(jwk)
  return encrypted
}
